export default "__VITE_ASSET__CYJGg_y8__"